import React from 'react'

import { SitemapListType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import { Link, Title, Wrapper } from './SitemapList.styled'

export const SitemapList = (props: SitemapListType): JSX.Element => {
    const { collections } = props

    return (
        <div>
            {collections.map((item) => (
                <Wrapper key={item.title}>
                    <Container>
                        <Title>{item.title}</Title>
                        <Grid container rowSpacing={2} columnSpacing={3}>
                            {item.links.map((link) => (
                                <Grid item xs={12} sm={6} md={3} key={`${link.label}-${link.link}`}>
                                    <Link to={link.link}>{link.label}</Link>
                                </Grid>
                            ))}
                        </Grid>
                    </Container>
                </Wrapper>
            ))}
        </div>
    )
}
